<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Student Royalties">
        <v-card-actions>
          <router-link :to="{ name: 'royalty' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card rounded="lg" elevation="3" dark class="my-4" color="accent lighten-1">
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-card-subtitle class="font-weight-medium white--text"><span class="body-1">Name :</span> {{ data1.studentName || '-' }}</v-card-subtitle>
            </v-col>
            <v-col cols="12" md="4">
              <v-card-subtitle class="font-weight-medium white--text"><span class="body-1">Gender :</span> {{ data1.gender==='MALE' ||data1.gender==='Male' ? 'Boy' :data1.gender==='FEMALE' ||data1.gender==='Female' ?'Girl': '-' }}</v-card-subtitle>
            </v-col>
            <v-col cols="12" md="4">
              <v-card-subtitle class="font-weight-medium white--text"><span class="body-1">B2B Enrollment :</span> {{ data1.enrollmentCode || '-' }}</v-card-subtitle>
            </v-col>
            <v-col cols="12" md="4">
              <v-card-subtitle class="font-weight-medium white--text"><span class="body-1">MCB Enrollment :</span> {{ data1.enrollmentNoMCB || '-' }}</v-card-subtitle>
            </v-col>
            <v-col cols="12" md="4">
              <v-card-subtitle class="font-weight-medium white--text"
                ><span class="body-1">Date of Admission :</span>
                {{ new Date(data1.dateOfAdmission).toLocaleDateString() != 'Invalid Date' ? new Date(data1.dateOfAdmission).toLocaleDateString() : '-' }}</v-card-subtitle
              >
            </v-col>
            <v-col cols="12" md="4">
              <v-card-subtitle class="font-weight-medium white--text"
                ><span class="body-1">Class :</span>
                {{ className || '-' }}
              </v-card-subtitle>
            </v-col>
          </v-row>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              <!-- Total Records : {{ total }} -->
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :search.sync="search"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="data"
          >
            <template v-slot:item.serviceTax="{ item }">
              <span v-if="flag == true">{{ item.serviceTax }}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.cgst="{ item }">
              <span v-if="flag == false">{{ item.serviceTax / 2 }}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.sgst="{ item }">
              <span v-if="flag == false">{{ item.serviceTax / 2 }}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.dueDate="{ item }">
              {{ new Date(item.dueDate).toLocaleDateString() }}
            </template>
            <template v-slot:item.paid="{ item }">
              <span v-if="item.franchiseeTransactionID != null" class="green--text font-weight-bold">
                PAID
              </span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.unpaid="{ item }">
              <div v-if="item.franchiseeTransactionID == null" class="error--text font-weight-bold">
                UNPAID
              </div>
            </template>
            <template v-slot:item.aescAmount="{ item }">
              <v-icon small>mdi-currency-inr</v-icon>
              <span>{{ item.aescAmount }}</span>
            </template>

            <template v-slot:item.aescPaidAmount="{ item }">
              <v-icon small>mdi-currency-inr</v-icon>
              <span>{{ item.aescPaidAmount }}</span>
            </template>

            <template v-slot:item.aescDueAmount="{ item }">
              <v-icon small>mdi-currency-inr</v-icon>
              <span>{{ item.aescDueAmount }}</span>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
    </v-container>
  </div>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'

export default {
  name: 'royalty',
  components: { MaterialCard, VCardComponent },
  props: ['StudentAdmissionID', 'franchiseeNo'],
  data () {
    return {
      flag: true,
      search: '',
      data: [],
      className: '',
      data1: '',
      paginated: false,
      perPage: 10,
      total: '',
      studentName: '',
      gender: '',
      enrollmentCode: '',
      dateOFAdmission: '',
      loadingComponent: null,
      headers: [
        { text: 'Fee Type', value: 'feeType', sortable: true },
        { text: 'Installment Name', value: 'installmentName', sortable: true },
        { text: 'IGST', value: 'serviceTax', sortable: true },
        { text: 'CGST', value: 'cgst', sortable: true },
        { text: 'SGST', value: 'sgst', sortable: true },
        { text: 'TDS', value: 'tds', sortable: true },
        { text: 'AESC Amount', value: 'aescAmount', sortable: true },
        { text: 'AESC Percent', value: 'aescPercent', sortable: true },
        { text: 'AESC Paid Amount', value: 'aescPaidAmount', sortable: true },
        { text: 'Due Date', value: 'dueDate', sortable: true },
        { text: 'Paid', value: 'paid', sortable: true },
        { text: 'Unpaid', value: 'unpaid', sortable: true },
        { text: 'Due Amount', value: 'aescDueAmount', sortable: true }
      ]
    }
  },
  created: async function () {
    await this.getRoyaltyList()
  },

  methods: {
    _headers () {
      return this.headers.filter(x => x.flag)
    },
    getRoyaltyList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        const response = await http.get(`${constants.API_URL}/api/student-royalty?studentAdmissionID=${this.StudentAdmissionID}`)
        if (response.data) {
          console.log(response.data.class)
          this.className = response.data.class
          this.data = response.data.studentRoyalties
          this.data1 = response.data.studentEnrollment
          this.order = response.data.orders
        } else {
          this.className = ''
          this.data = ''
          this.data1 = ''
          this.order = ''
        }
        if (response.data.franchisee.state !== 'Maharashtra') {
          this.flag = true
        } else {
          this.flag = false
        }

        this.total = this.data.length

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching ', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
